import { getFormattedDateValue } from 'utils/Dates';

export const formatDate = (dateStr?: string | null) =>
  getFormattedDateValue({ date: dateStr, formatString: 'dd MMM yyyy', filler: '—' });

export const formatMonthYear = (dateStr?: string | null) =>
  getFormattedDateValue({ date: dateStr, formatString: 'MMMM yyyy', filler: '—' });

export const getEmiEndMonth = (
  recoveryStartFrom?: string | null,
  tenure?: number | null,
): string => {
  if (!recoveryStartFrom || !tenure) return '—';
  const start = new Date(recoveryStartFrom);
  start.setMonth(start.getMonth() + tenure - 1);
  return formatMonthYear(start.toISOString());
};
